(function () {
var $d695f5e1c141e4b3$var$selectors = {
    iconTile: '.tile--image-size-icon',
    icon: '.tile__icon'
};
var $d695f5e1c141e4b3$var$iconTiles = document.querySelectorAll($d695f5e1c141e4b3$var$selectors.iconTile);
var $d695f5e1c141e4b3$var$observer = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
        var tile = entry.target;
        if (entry.isIntersecting) {
            var icon = tile.querySelector($d695f5e1c141e4b3$var$selectors.icon);
            if (icon) {
                var maskImage = icon.getAttribute('data-mask-img');
                if (maskImage) {
                    icon.style.setProperty('--mask-img-url', "url(".concat(maskImage, ")"));
                    icon.setAttribute('data-loaded', 'true');
                }
            }
            observer.unobserve(icon);
        }
    });
});
if ($d695f5e1c141e4b3$var$iconTiles.length) $d695f5e1c141e4b3$var$iconTiles.forEach(function(tile) {
    return $d695f5e1c141e4b3$var$observer.observe(tile);
});

})();
//# sourceMappingURL=tile.min.js.map
